@if (type === 'basic') {
  <button
    [disabled]="disable"
    [ngClass]="customClass"
    #tooltip="matTooltip"
    mat-button
    [matTooltip]="hoverTooltip || message"
    [matTooltipDisabled]="!hoverTooltip"
    [matTooltipPosition]="position"
    aria-label="Copy to clipboard"
    (click)="copyToClipboard()">
    {{ buttonText }}
  </button>
} @else if (type === 'icon-text') {
  <button
    [disabled]="disable"
    [ngClass]="customClass"
    #tooltip="matTooltip"
    mat-button
    [matTooltip]="hoverTooltip || message"
    [matTooltipDisabled]="!hoverTooltip"
    [matTooltipPosition]="position"
    aria-label="Copy to clipboard"
    (click)="copyToClipboard()">
    <mat-icon>{{ content_copy }}</mat-icon>
    {{ buttonText }}
  </button>
} @else {
  <button
    [disabled]="disable"
    [ngClass]="customClass || 'mat-icon-button-small'"
    #tooltip="matTooltip"
    matIconButton
    [matTooltip]="hoverTooltip || message"
    [matTooltipDisabled]="!hoverTooltip"
    [matTooltipPosition]="position"
    aria-label="Copy to clipboard"
    (click)="copyToClipboard()">
    <mat-icon>{{ content_copy }}</mat-icon>
  </button>
}

